import persistPlugin from '@rematch/persist';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import JobsAlert from './components/jobs';
// scroll bar
import * as serviceWorker from './serviceWorker';

import './assets/third-party/simplebar.css';

// third-party
import { getPersistor } from '@rematch/persist';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
// apex-chart
import './assets/third-party/apex-chart.css';
import './index.css';
// project import
import thunk from 'redux-thunk';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { init } from '@rematch/core';
import storage from 'redux-persist/lib/storage';
import { VARIANT } from './config';
import { variants } from './constants/variants';
import * as models from './store';
import menu from './store/reducers';

let ico;
if (VARIANT === variants.COLORIN) {
  require('./colorin.css');
  ico = require('./assets/images/icons/ico-30.ico');
  document.title = 'Colorin | Tintométrico';
} else if (VARIANT === variants.TERSUAVE) {
  require('./tersuave.css');
  ico = require('./assets/images/icons/ico-31.ico');
  document.title = 'Hay color | Tintométrico';
  console.log('Hay color');
} else if (VARIANT === variants.INDUSTRIA) {
  require('./industria.css');
  ico = require('./assets/images/icons/ico-32.ico');
  document.title = 'Indulac | Tintométrico';
} else if (VARIANT === variants.TECLUM) {
  require('./teclum.css');
  ico = require('./assets/images/icons/ico-31.ico');
  document.title = 'Teclum | Tintométrico';
  console.log('Teclum');
}
// document.body.classList.add(variants.TERSUAVE);
document.body.classList.add(VARIANT);
let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
if (!link) {
  link = document.createElement('link');
  link.rel = 'icon';
  document.head.appendChild(link);
}
link.href = ico;
const configs = {
  storage: storage,
  key: 'tintometrico',
};
declare global {
  interface Window {
    config: any;
  }
}
window.config = window.config || {};

export const store = init({
  models,
  redux: {
    devtoolOptions: {
      disabled: false, //process.env.REACT_APP_REDUX_DEVTOOLS_DISABLED === "true",
    },
    reducers: {
      menu: menu,
    },
    middlewares: [thunk],
  },
  //@ts-ignore
  plugins: [persistPlugin(configs)],
});

const persistor = getPersistor();

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <ReduxProvider store={store}>
    <PersistGate persistor={persistor}>
      <HashRouter basename="/">
        <App />
        <JobsAlert open={true} />
      </HashRouter>
    </PersistGate>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
